import axios from 'axios';

import AppSettings from '../../../../../core/AppSettings'

export const getMiniCartResponse = ()=>{
    let currTime = new Date().getTime();
    const gmMiniCartURL = "/wcs/resources/store/" + AppSettings.storeId + "/GMCart/@self/getMiniCartData?cache="+currTime;    
    return axios.get(gmMiniCartURL).then((response) => { return response; }, (error) => { throw "GET MINICART DATA ERROR: " + error; });
};